export default "__VITE_ASSET__e1bbcf8b__"